import { useCallback, useEffect, useRef, useState } from "react"
import { key_local_storage_cart, url_images, urlapi } from "../../lib/backend/data"
import Carrito from "../Header/carrito"
import { Button, Card, Col, Form, Row } from "react-bootstrap"
import { GoGift } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux"
import { Link, useParams } from "react-router-dom"
import { FaAngleLeft, FaCheckCircle } from "react-icons/fa"
import { refrescarUser } from "../../redux/actions/user"
import { formatoMoneda, validateEmail } from "../../lib/helpers/helpers"
import { Alert } from "@mui/material"
import { toast } from "react-toastify"
import Skeleton from "react-loading-skeleton"
import paymentData from "../Checkout/data"
import { MdOutlineLocalShipping } from "react-icons/md";
import { FiBox } from "react-icons/fi";
import { FaRegClock } from "react-icons/fa6";
const logos = paymentData.logos
const descripciones = paymentData.descripciones

const DetallesOrden = () => {
    const { id } = useParams()
    const [ idPedido, setIdPedido ] = useState(id)
    const [ pedido, setPedido ] = useState(false)
    const carrito = localStorage.getItem(key_local_storage_cart) ? JSON.parse(localStorage.getItem(key_local_storage_cart) ) : []
    const [ paymentMethod, setPaymentMethod ] = useState(false)
    const [ shipmentMethod, setShipmentMethod ] = useState(false)
    const direcciones = useSelector(state => state.direcciones)
    const sitio = useSelector(state => state.sitio)
    const [ metodos_pago, setMetodosPago ] = useState([])
    const [ loadingPaymentMethods, setLoadingPaymentMethods ] = useState(false)
    const [ loading, setLoading ] = useState(false)
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)
    const [ checkout, setCheckout ] = useState({
        isGift: false,
        giftOptions: {}
    })
    const purchaseTracked = useRef(false)
    const khipuChequeado = useRef(false)
    // Mientras Khipu no resuelva, la página no debe ofrecer pagar de nuevo un pedido ya pagado.
    const [ confirmandoKhipu, setConfirmandoKhipu ] = useState(false)

    useEffect(() => {
        consultarOrden()
        consultarMetodosPago()
    }, [])

    const trackFacebookEvent = useCallback((eventName, payload) => {
        if (typeof window === "undefined") return
        if (typeof window.fbq !== "function") return
        window.fbq("track", eventName, payload)
    }, [])

    useEffect(() => {
        if(!pedido || pedido.paid !== true) return
        if(purchaseTracked.current) return
        purchaseTracked.current = true
        const items = Array.isArray(pedido.productos) ? pedido.productos : []
        const totalItems = items.reduce((sum, item) => {
            const qty = parseInt(item.cantidad)
            return sum + (isNaN(qty) ? 0 : qty)
        }, 0)
        const envio = pedido.shipment_data?.value ? pedido.shipment_data?.value : 0
        const totalValue = Math.max(0, Math.round(pedido.total || 0))
        trackFacebookEvent("Purchase", {
            content_ids: items.map(item => item._id),
            content_type: "product",
            currency: "CLP",
            num_items: totalItems,
            value: totalValue,
            order_id: pedido.pedido || pedido._id
        })
    }, [ pedido, trackFacebookEvent ])

        const consultarMetodosPago = async () => {
            setLoadingPaymentMethods(true)
            return fetch(`${urlapi}/payments/methods`,{
                method:'POST',
                body: JSON.stringify({
                    host: window.location.host
                }),
                headers: {
                    'Content-Type':'application/json',
                }
            })
            .then(res => res.json())
            .then(res => {
                if(Array.isArray(res)) setMetodosPago(res.map(e => ({ ...e, name: e.sub_tipo === "transbank" ? "webpay" : e.sub_tipo, id: e.sub_tipo === "transbank" ? "webpay" : e.sub_tipo, logo: logos[e.sub_tipo], description: descripciones[e.sub_tipo] })))
                return setLoadingPaymentMethods(false)
            })
            .catch(error => {
                setLoadingPaymentMethods(false)
            })
    
        }
    

    const seleccionMetodo = () => {
        if(loadingPaymentMethods) return <Skeleton count={3} height={50} />
        
        return <div className="mt-3">
            <p>Selecciona el método de pago <b style={{ fontWeight: 600 }}>haciendo click</b></p>
            {
                metodos_pago.map((e, i) => {
                    return <Card key={`metodo-pago-${i}`} className="mb-3 p-3 hover " style={{ border: paymentMethod === e.name ? "1px solid black" : "none" }} onClick={() => setPaymentMethod(e.name)}>
                        <Row>
                        <Col xs={6}>{ e.logo ? <img style={{ maxWidth: 100 }} src={e.logo} alt={e.name} /> : <h5 style={{ textTransform: "capitalize" }} className="mb-0">{e.name}</h5> }</Col>
                        <Col xs={6} className="text-right"><p className="mb-0">{e.description}</p></Col>
                        </Row>
                    </Card>
                })
            }
        </div>
    }

    const handleChangeGift = (e) => {
        const { name, value } = e.target
        setCheckout(prev => {
            return {
                ...prev,
                giftOptions: {
                    ...prev.giftOptions,
                    [name]: value
                }
            }
        })
    }

    const procesarPagoWebpay = async (url, token) => {
        if (url && token) {
            // Crea un formulario dinámico
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = url;
            
            // Crea un input oculto para el token
            const inputToken = document.createElement('input');
            inputToken.type = 'hidden';
            inputToken.name = 'token_ws';
            inputToken.value = token;
            
            form.appendChild(inputToken);
            document.body.appendChild(form);
            
            // Envía el formulario
            form.submit();
            }
    } 

    /**
     * Khipu se paga en su propio sitio, con redirección completa.
     *
     * La vuelta entra por el backend, que confirma el pago antes de devolver al comprador acá; por
     * eso la orden ya aparece pagada. Con el widget en modal eso no era posible: Khipu no redirige
     * nada y no hay vuelta que interceptar.
     */
    const iniciarPagoKhipu = (res, id) => {
        if (!res?.payment_url) return toast.error("No se pudo iniciar el pago, intenta nuevamente")

        // Respaldo para el sondeo de esta página si el pago quedara sin confirmar.
        try { sessionStorage.setItem(`khipu_payment_${id}`, res.payment_id) } catch (error) { }

        return window.location = res.payment_url
    }

    const payByMethod = (res, id, payment_method) => {
        if(payment_method === "webpay"){
            if(res?.url && res?.token){
                procesarPagoWebpay(res?.url, res?.token)
            } else {
                toast.error("Ocurrió un error al procesar el pago")
            }
        } else if( payment_method === "fintoc"){
            if(res.id){
                if (window.Fintoc) {
                    const widget = window.Fintoc.create({
                        sessionToken: res.session_token,
                        product: 'payments',
                        publicKey: 'pk_test__ZVaFZ4Za8AT_nAnWEAx7zyx7RxigHuztsuw1eUs1HM',
                        onSuccess: () => window.location = `/order-details/${id}`,
                      });
                      widget.open();
                } else {
                    toast.error("Método de pago no disponible por el momento")
                }
            }
        } else if( payment_method === "khipu"){
            iniciarPagoKhipu(res, id)
        } else if( payment_method === "transferencia"){
            window.location = `/order-details/${id}`
        }
    }

    const pagarPedido = async (id, payment_) => {
        const payment_method = payment_.toString().toLowerCase()
        
            return fetch(`${urlapi}/payments/pay`,{
                method:'POST',
                body: JSON.stringify({
                    id,
                    payment_method
                }),
                headers: {
                    'Content-Type':'application/json',
                }
            })
            .then(res => res.json())
            .then(res => {
                if(res?.errorMessage){
                    toast.error(res.errorMessage)
                    return setLoading(false)
                }
                payByMethod(res, id, payment_method)
                return setLoading(false)
            })
            .catch(error => {
                setLoading(false)
            })
    }

    /**
     * Cierra el desfase entre la vuelta del comprador y la conciliación de Khipu.
     *
     * El backend ya espera unos segundos antes de devolverlo acá, pero una transferencia puede tardar
     * bastante más: en los pagos medidos, entre 46 segundos y 4 minutos. Cuando pasa eso el comprador
     * llega antes de que su pago exista, y sin este sondeo la página se queda diciendo "pendiente"
     * sobre un pago que va a salir bien —y el evento `Purchase` de Facebook, que cuelga de
     * `pedido.paid`, nunca se dispara—.
     *
     * Consulta el endpoint de estado y no solo el pedido: ahí el backend reconfirma contra la API de
     * Khipu, así que también rescata el caso en que el webhook se perdió.
     */
    const confirmarPagoKhipuPendiente = useCallback(async () => {
        let payment_id = null
        try { payment_id = sessionStorage.getItem(`khipu_payment_${idPedido}`) } catch (error) { }
        // El id del pedido sirve igual: el backend busca por ahí el último cobro de Khipu. Es lo que
        // salva el caso de volver en otra pestaña o desde el mail, donde `sessionStorage` está vacío
        // y es justamente cuando el sondeo hace falta.
        const referencia = payment_id || idPedido
        if(!referencia) return false

        const consultarEstado = () => fetch(`${urlapi}/payments/khipu/status/${referencia}`)
            .then(res => res.json())
            .catch(() => null)

        const cerrarComoPagado = () => {
            try { sessionStorage.removeItem(`khipu_payment_${idPedido}`) } catch (error) { }
            return consultarOrden()
        }

        // Un pago rechazado o vencido no va a cambiar por esperar más.
        const yaResuelto = (estado) => ["rejected", "canceled", "expired"].includes(estado?.status)

        /*
         * La primera consulta decide si hay algo que esperar. Sin cobro de Khipu para este pedido
         * —otro medio de pago, o una orden que nunca se pagó— hay que salir sin anunciar nada: el
         * aviso de "confirmando" quedaría puesto para siempre sobre un pedido que nadie está pagando.
         */
        const primera = await consultarEstado()
        if(!primera || primera.errorMessage) return false
        if(primera.paid === true) return cerrarComoPagado()
        if(yaResuelto(primera)) return false

        setConfirmandoKhipu(true)

        /*
         * Los intervalos se van espaciando: seguido al principio, porque una transferencia inmediata
         * cierra en segundos, y más lento después para no golpear la API mientras el banco responde.
         * En total cubre algo más de dos minutos, que es el rango real de estas conciliaciones.
         */
        const ESPERAS = [2000, 2000, 3000, 3000, 5000, 5000, 5000, 10000, 10000, 15000, 15000, 20000, 20000, 30000]

        for (const espera of ESPERAS) {
            await new Promise(resolve => setTimeout(resolve, espera))
            const estado = await consultarEstado()

            if(estado?.paid === true){
                setConfirmandoKhipu(false)
                return cerrarComoPagado()
            }
            if(yaResuelto(estado)) break
        }

        setConfirmandoKhipu(false)
        return false
    }, [ idPedido ])

    useEffect(() => {
        if(!pedido || pedido.paid === true) return
        if(khipuChequeado.current) return
        khipuChequeado.current = true
        confirmarPagoKhipuPendiente()
    }, [ pedido, confirmarPagoKhipuPendiente ])

    const consultarOrden = async () => {
        setLoading(true)
        return fetch(`${urlapi}/pedidos/details?id=${idPedido}`,{
            method:'GET',
            headers: {
                'Content-Type':'application/json',
            }
        })
        .then(res => {
            return res.json()
        })
        .then(res => {
            if(!res){
                toast.error('Sin datos')
            } else if(res.errorMessage){
                toast.error(res.errorMessage)
            } else if(res._id){
                setPedido(res)
                if(res?.payment_method) setPaymentMethod(res?.payment_method)
            }
            // return setLoadingCreacion(false)
            setLoading(false)
        })
        .catch(error => {
            setLoading(false)
            toast.error("Error al consultar la información, intente nuevamente")
            // return setLoadingCreacion(false)
        })

    }

    const completarPedido = () => {
        console.log("payment", paymentMethod)
        if(!paymentMethod) return toast.error("Debes seleccionar un método de pago")
        const indexarMetodosPago = metodos_pago.reduce((prev,next) => {
            prev[next.name] = next.id
            return prev
        }, {})

        if(idPedido){
            pagarPedido(idPedido, indexarMetodosPago[paymentMethod] )
        }
            
    }

    const giftOptions = () => {
        if(!checkout.isGift) return false
        return <div>
            <Card className="p-3 shadow">
            
            <Row>
                <Col md={4}>
                <h5><GoGift size={40} /></h5>
                <h5 className="mb-0">Sobre tu obsequio </h5>
                </Col>
                <Col md={4}>
                    <label className="form-control-label d-block">De</label>
                    <input className="form-control mb-0" value={checkout.giftOptions?.de} name="de" onChange={handleChangeGift} />
                </Col>
                <Col md={4}>
                    <label className="form-control-label d-block">Para</label>
                    <input className="form-control mb-0" value={checkout.giftOptions?.para} name="para" onChange={handleChangeGift} />
                </Col>
            </Row>
            </Card>
        </div>
    }

    const resumen = () => {
        let calcular_total = carrito.reduce((prev, next) => {
            let cantidad = parseInt(next.cantidad)
            if(isNaN(cantidad)) cantidad = 0
            return prev + (next.precio * cantidad)
          }, 0)

          const envio = pedido.shipment_data?.value ? pedido.shipment_data?.value : 0
          return <div>
                <h5><FiBox /> Productos</h5>
              <div className="p-3">
                <Carrito typeView="very-simple" carrito={pedido.productos} replaceAction={<div></div>} />
              <Row>
                <Col md={6} xs={0}></Col>
                <Col md={2} xs={6}>Sub total</Col>
                <Col md={4} xs={6} className="text-right">{formatoMoneda(Math.round(pedido.sub_total))}</Col>

                <Col md={6} xs={0}></Col>
                <Col md={2} xs={6}>Envío</Col>
                <Col md={4} xs={6} className="text-right">{formatoMoneda(pedido.shipment_data?.value)}</Col>

                {
                                    pedido.discount ? <>
                                        <Col md={6} xs={0}></Col>
                                        <Col md={2} xs={6}>Descuento</Col>
                                        <Col md={4} xs={6} className="text-right">- {formatoMoneda(Math.round(pedido.discount?.value))}</Col>
                                </> : <>
                                    </>
                                }
                
                <Col md={6} xs={0}></Col>
                <Col md={2} xs={6}>Total</Col>
                <Col md={4} xs={6} className="text-right">{formatoMoneda((Math.round(pedido.total)))}</Col>

              </Row>
              </div>
          </div>
    }

    const handleChangeUser = (e) => {
        const { name, value } = e.target
        const instancia_usuario = JSON.parse(JSON.stringify(user))
        let valor = value
        if(name === "phone"){
            const prefix = "56";
            if(value.startsWith(prefix)) {
                valor = value;
            } else {
                valor = value.length < 2 ? prefix : (prefix + valor)
            }
            valor = valor.substring(0,11)
        }
        instancia_usuario.billing[name] = valor
        dispatch(refrescarUser(instancia_usuario))
    }

    const seleccionarEnvio = (tar) => {
        return setShipmentMethod(tar)
    }

    const viewDetailsPaymentMethod = (method) => {
        const i = metodos_pago.findIndex(e => e.name === method)
        if(i < 0) return false
        return <Card className="p-3 mb-3">
            {
                metodos_pago[i].detalles.fields.map((e, i) => {
                    return <div>
                        <h6>{e.label}</h6>
                        <p className="mb-0">{e.value}</p>
                    </div>
                })
            }
        </Card>
    }

    const mostrarMetodoEnvio = () => {
        return <div>
            <h5><MdOutlineLocalShipping /> Método de envío</h5>
            <h3><b>{pedido.shipment_data?.provider_web || pedido.shipment_data?.code}</b></h3>
        </div>
    }

    /**
     * Cómo se rotula el pago en el encabezado.
     *
     * Son tres estados y no dos: entre "pendiente" y "exitoso" está el rato en que el comprador ya
     * pagó y el banco todavía no confirma. Mostrar "pendiente" ahí es engañoso y lo empuja a pagar
     * de nuevo.
     */
    const estadoDelPago = () => {
        if(pedido.paid === true) return <><FaCheckCircle color="green" /> Pago exitoso</>
        if(confirmandoKhipu) return <><FaRegClock color="#0288d1" /> Confirmando tu pago</>
        return <><FaRegClock color="gray" /> Pago pendiente</>
    }

    const mostrarPago = () => {
        if(pedido.paid === true) return false
        // Ofrecer el selector mientras se confirma invita a pagar dos veces la misma orden.
        if(confirmandoKhipu) return false
        
        return <div>

            <h4>Detalles del pago</h4>
            <p>Completa tu compra seleccionando tu opción preferida para comprar</p>
            {seleccionMetodo()}
            {paymentMethod === "transferencia" ? viewDetailsPaymentMethod(pedido.payment_method) : <Button variant="primary" className="w-100 mt-3" disabled={loading} onClick={() => completarPedido()}>{loading ? "ESPERE UN MOMENTO..." : "PAGAR"}</Button> }
        </div>
    }

    const mostrarDetalles = () => {
        if(loading) return <Skeleton count={5} />
        return <div >
            <Row>
                <Col>
                <Row>
                <Col md={3} xs={12}>
                    <label className="form-control-label d-block">Número de pedido</label>
                    <p>{pedido?.pedido}</p>
                </Col>
                <Col md={3} xs={12}>
                    <label className="form-control-label d-block">Tu nombre</label>
                    <p>{pedido?.orden?.billing?.first_name}</p>
                </Col>
                <Col md={3} xs={12}>
                    <label className="form-control-label d-block">Correo electrónico</label>
                    <p>{pedido?.orden?.billing?.email}</p>
                    
                </Col>
                <Col md={3  } xs={12}>
                    <label className="form-control-label d-block">Teléfono</label>
                    <p>{pedido?.orden?.billing?.phone}</p>
                </Col>
            </Row>
            
                    <hr />
                    <h4>Detalles del envío</h4>

                    <Row className="mt-2 mb-1">
                        <Col md={4}>
                        <label className="form-control-label d-block">Dirección</label>
                        <p>{pedido?.orden?.billing?.address_1}</p>
                        </Col>
                        <Col md={4}>
                        <label className="form-control-label d-block">Depto./Oficina/Piso</label>
                        <p>{pedido?.orden?.billing?.address_2 || "Sin datos"}</p>
                        </Col>
                        <Col>
                        <label className="form-control-label d-block mb-0">Región</label>
                        <p><b>{pedido?.orden?.geo_datos?.level1}</b></p></Col>
                        <Col>
                        <label className="form-control-label d-block mb-0">Ciudad</label>
                        <p><b>{user?.geo_datos?.level2}</b></p></Col>
                        <Col>
                        <label className="form-control-label d-block mb-0">Comuna</label>
                        <p><b>{pedido?.orden?.geo_datos?.level3}</b></p>
                        </Col>
                        
                    </Row>
                    <Card className="p-3">
                    <Row>
                        <Col className="mb-3" lg={6} md={6} xs={12}>{resumen()}</Col>
                        <Col className="mb-3" lg={6} md={6} xs={12}>
                        {mostrarMetodoEnvio()}
                        {mostrarPago()}

</Col>
                    </Row>
            </Card>
            
            </Col>
            </Row>
        </div>
    }

    return <div className="p-3">
            {sitio.logo ? (
              <img
                src={sitio.logo}
                alt="Logo"
                className="mb-3"
                style={{ maxHeight: 50, maxWidth: "100%" }}
              />
            ) : (
              <h2>{sitio.titulo}</h2>
            )}
            <Link to="/"><p className="text-dark d-inline-block"><FaAngleLeft /> <b>Volver a la tienda</b></p></Link>

        <h4>Detalles de tu pedido <b>{pedido?.pedido}</b> {estadoDelPago()}</h4>
        {
            /*
             * Una transferencia tarda en conciliar —entre 46 segundos y 4 minutos en los pagos
             * medidos—, así que el comprador puede llegar antes de que su pago exista. Decirle
             * "pendiente" a secas lo empuja a pagar de nuevo; esto le dice que su plata ya salió y
             * que solo falta el banco.
             */
            confirmandoKhipu ? <Alert severity="info" className="mb-3">
                Estamos confirmando tu pago con el banco. Puede tardar un par de minutos: no cierres esta página ni vuelvas a pagar.
            </Alert> : false
        }
        <hr/>
        {mostrarDetalles()}
    </div>
}

export default DetallesOrden
